export default __webpack_public_path__ + "static/media/Spectra_HTB.693947ef.md";